import React, { useState } from 'react';
import { Building2, Package, Globe, Phone, Mail } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useToast } from '../hooks/use-toast';
import { Helmet } from 'react-helmet-async';

const BusinessShippingPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', company: '' });
  const { toast } = useToast();
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    toast({ title: "Quote Request Received!", description: "We'll contact you about business shipping solutions." });
    setFormData({ name: '', email: '', phone: '', company: '' });
  };

  return (
    <>
      <Helmet>
        <title>Business & E-Commerce Shipping Canada | International Solutions – Shippzy</title>
        <meta name="description" content="Business and e-commerce international shipping from Canada. Bulk rates, account management, worldwide delivery for online stores and Canadian businesses." />
        <link rel="canonical" href="https://www.shippzy.ca/business-ecommerce-shipping" />
      </Helmet>
      <div className="min-h-screen bg-white">
        <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">Business & E-Commerce Shipping</h1>
              <p className="text-xl text-gray-300 mb-8">International shipping solutions for Canadian businesses and online stores. Competitive bulk rates, dedicated account management, and worldwide delivery network.</p>
              <Button className="bg-gradient-to-r from-red-600 to-yellow-500 hover:from-red-700 hover:to-yellow-600 text-white px-8 py-6 text-lg" onClick={() => document.getElementById('quote-form').scrollIntoView({ behavior: 'smooth' })}>Get Business Quote</Button>
            </div>
          </div>
        </section>
        <section id="quote-form" className="py-20 bg-gradient-to-r from-red-600 to-yellow-500">
          <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="shadow-2xl">
              <CardHeader><CardTitle className="text-2xl text-center">Get Business Shipping Quote</CardTitle></CardHeader>
              <CardContent>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <Input name="name" value={formData.name} onChange={handleChange} required placeholder="Your name" />
                  <Input name="company" value={formData.company} onChange={handleChange} placeholder="Company name" />
                  <Input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="your@email.com" />
                  <Input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder="+1 (123) 456-7890" />
                  <Button type="submit" className="w-full bg-gradient-to-r from-red-600 to-yellow-500 text-white h-12">Get Quote Now</Button>
                </form>
              </CardContent>
            </Card>
          </div>
        </section>
      </div>
    </>
  );
};

export default BusinessShippingPage;
